import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import * as RUM from "../../lib/rum";
export default class ErrorBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error: error.message };
    }
    componentDidCatch(error) {
        window.Sentry.captureException(error);
        RUM.addData("hasComponentError", true);
        console.error("ErrorBoundary caught", error);
        this.setState({ error: error.message });
    }
    render() {
        if (this.state.error) {
            if (this.props.onError) {
                return this.props.onError();
            }
            return _jsx("div", { children: "Component failed to load." });
        }
        return this.props.children;
    }
}
